var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-06"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8787 2.7068C16.0503 1.53523 17.9497 1.53523 19.1213 2.7068L21.2929 4.87838C22.4645 6.04995 22.4645 7.94945 21.2929 9.12102L13.7071 16.7068C13.5196 16.8943 13.2652 16.9997 13 16.9997H8C7.44772 16.9997 7 16.552 7 15.9997V10.9997C7 10.7345 7.10536 10.4801 7.29289 10.2926L14.8787 2.7068ZM17.7071 4.12102C17.3166 3.73049 16.6834 3.73049 16.2929 4.12102L15.4142 4.9997L19 8.58548L19.8787 7.7068C20.2692 7.31628 20.2692 6.68312 19.8787 6.29259L17.7071 4.12102ZM17.5858 9.9997L14 6.41391L9 11.4139V14.9997H12.5858L17.5858 9.9997ZM7 3.9997C5.34315 3.9997 4 5.34284 4 6.9997V16.9997C4 18.6566 5.34315 19.9997 7 19.9997H17C18.6569 19.9997 20 18.6566 20 16.9997V13.9997C20 13.4474 20.4477 12.9997 21 12.9997C21.5523 12.9997 22 13.4474 22 13.9997V16.9997C22 19.7611 19.7614 21.9997 17 21.9997H7C4.23858 21.9997 2 19.7611 2 16.9997V6.9997C2 4.23827 4.23858 1.9997 7 1.9997H10C10.5523 1.9997 11 2.44741 11 2.9997C11 3.55198 10.5523 3.9997 10 3.9997H7Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f61224f4133f0daf8670f3cae134e30.svg";
export { ForwardRef as ReactComponent };